import { Component, Input, OnInit, ViewChild } from "@angular/core";

import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";

import { CanvasService } from "@services/canvas.service";
import { CommonService } from "@services/common.service";
import { faEdit } from "@fortawesome/pro-regular-svg-icons";
@Component({
    selector: "app-drilldown-table-chart",
    templateUrl: "./drilldown-table-chart.component.html",
    styleUrls: ["./drilldown-table-chart.component.scss"],
    standalone: false
})
export class DrilldownTableChartComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined;
  @ViewChild(MatSort) sort!: MatSort;
  @Input() form: any;
  @Input() userOptions: any;
  @Input() index!: number;

  constructor(
    private canvasService: CanvasService,
    public commonService: CommonService
  ) {}
  childForm: any;

  public columns!: Array<any>;
  public displayedColumns!: Array<any>;
  public displayedHeaderColumns!: Array<any>;
  public dataSource!: any;
  public minwidth: any;
  public data: any = [];
  public dataPoints: any = [];
  public dataPointId: any;
  public filter: any;
  public loading: boolean = true;
  displayDrilldown = true;
  drilldownLink = "http://www.quantivate.com";
  faEdit = faEdit;

  public featureFlags: any = [];

  ngOnInit() {
    this.featureFlags = JSON.parse(sessionStorage.getItem("featureFlags"));

    if (this.userOptions) {
      this.dataPointId =
        this.userOptions.drillDownFilters[this.index].dataPointId;
      this.filter = this.userOptions.drillDownFilters[this.index];

      this.canvasService
        .drilldown(this.form, this.dataPointId, this.filter)
        .subscribe(
          (success: any) => {
            if (success) {
              this.data = success.data.chartObject;
              this.dataPoints = success.data.dataPoints;
              this.getAllColumnsAndData();
            }
          },
          (err: any) => {
            this.loading = false;
            console.log("no chart data returned");
          }
        );
    }
  }
  resizeData() {
    setTimeout(() => {
      this.displayedColumns.forEach((col: any) => {
        col = this.commonService.sanitizeColumn(col);
        const columnElts = document.getElementsByClassName(
          "mat-column-" + col.split(" ").join("-")
        );
        let temp = columnElts[0] as HTMLDivElement;
        let cssValue = "300px";
        if (temp && temp.style && temp.style.width) {
          cssValue = temp.style.width;
        }
        for (let i = 1; i < columnElts.length; i++) {
          const currentEl = columnElts[i] as HTMLDivElement;
          currentEl.style.width = cssValue;
        }
      });
    }, 10);
  }

  displayHeader(col: any) {
    const result = this.dataPoints.data.filter(
      (header: any) => header.id == col
    );
    if (result && result.length > 0) {
      return result[0].name;
    } else {
      return col;
    }
  }

  getAllColumnsAndData() {
    if (this.data.constructor != Array) {
      let temp: any[] = [];
      var result = Object.keys(this.data).map((key) => [this.data[key]]);

      result.forEach((element: any, index: any) => {
        temp.push(element[0]);
      });
      this.data = temp;
    }
    if (this.data && this.data.length > 0) {
      const columns = this.data
        .reduce((columns: any, row: {}) => {
          return [...columns, ...Object.keys(row)];
        }, [])
        .reduce((columns: string | any[], column: any) => {
          return columns.includes(column) ? columns : [...columns, column];
        }, []);
      this.columns = columns.map((column: string) => {
        return {
          columnDef: column,
          header: column,
          cell: (element: any) => `${element[column] ? element[column] : ``}`,
        };
      });
      this.displayedColumns = this.columns.map((c) => c.columnDef);
      //rename headerColumns
      this.displayedHeaderColumns = [];
      this.displayedColumns.forEach((headerItem: any) => {
        this.displayedHeaderColumns.push(this.displayHeader(headerItem));
      });
      this.dataSource = new MatTableDataSource(<any>this.data);

      setTimeout(() => {
        this.dataSource.sort = this.sort;
      }, 10);
      this.resizeData();
    } else {
      this.loading = false;
      console.log("no chart data returned");
    }
  }
}
